import { initNavigation } from "./components/navigation.ts";
import { initOffcanvas } from "./components/offcanvas.ts";
import { initScrollToTop } from "./components/scroll-to-top.ts";
import { initSlider } from "./components/slider.ts";

document.addEventListener("DOMContentLoaded", (): void => {
    initNavigation()
    initOffcanvas();
    initScrollToTop();
    initSlider();
})
